"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlatformService = void 0;
var _platform = require("../controllers/platform.controller");
var PlatformService = {
  organization: {
    list: _platform.config.organization + "/list",
    detail: _platform.config.organization + "/details",
    listsoftdeleted: _platform.config.organization + "/list/soft/deleted",
    fetch: _platform.config.organization,
    add: _platform.config.organization,
    delete: _platform.config.organization + "/delete/hard",
    vimeoUpdate: _platform.config.organization + "/vimeo",
    platformUpdate: _platform.config.organization + "/platform"
  },
  platformKey: {
    add: _platform.config.platformKey,
    fetch: _platform.config.platformKey + "/verify"
  },
  platform: {
    tenantDetails: _platform.config.platform + "/public/tenantdetails",
    apiurl: _platform.config.platform + "/public/apiurl"
  },
  account: {
    disable: _platform.config.account + "/disable",
    enable: _platform.config.account + "/enable",
    restore: _platform.config.account + "/restore",
    clean: _platform.config.account + "/clean",
    delete: _platform.config.account + "/delete",
    harddelete: _platform.config.account + "/bulk/delete-permanent"
  },
  broadcast: {
    fetch: _platform.config.broadcast + "/templates",
    list: _platform.config.broadcast + "/templates/list",
    softDelete: _platform.config.broadcast + "/templates/delete/soft",
    softDeleteRestore: _platform.config.broadcast + "/templates/delete/soft/restore",
    softDeletedList: _platform.config.broadcast + "/templates/list/soft/deleted",
    bulkSoftDelete: _platform.config.broadcast + "/templates/bulk/delete/soft",
    bulkHardDelete: _platform.config.broadcast + "/templates/bulk/delete/hard",
    bulkRestore: _platform.config.broadcast + "/templates/bulk/delete/soft/restore"
  },
  brand: {
    fetch: _platform.config.brand,
    access: _platform.config.brand + "/access",
    list: _platform.config.brand + "/list",
    delete: _platform.config.brand + "/delete/hard",
    add: _platform.config.brand,
    update: _platform.config.brand,
    remove: _platform.config.brand + "/admin",
    adminList: _platform.config.brand + "/admin/list",
    brandContentList: _platform.config.brand + "/content/list",
    accessList: _platform.config.brand + "/access-permission",
    apply: _platform.config.brand + "/access-permission",
    softDelete: _platform.config.brand + "/delete/soft",
    softDeleteRestore: _platform.config.brand + "/delete/soft/restore",
    softDeletedList: _platform.config.brand + "/list/soft/deleted",
    bulkSoftDelete: _platform.config.brand + "/bulk/delete/soft",
    bulkHardDelete: _platform.config.brand + "/bulk/delete/hard",
    bulkRestore: _platform.config.brand + "/bulk/delete/soft/restore"
  },
  palette: {
    list: _platform.config.palette + "/list",
    add: _platform.config.palette,
    rename: _platform.config.palette + "/rename",
    delete: _platform.config.palette,
    softDelete: _platform.config.palette + "/delete/soft",
    softDeleteRestore: _platform.config.palette + "/delete/soft/restore",
    softDeletedList: _platform.config.palette + "/list/soft/deleted",
    bulkSoftDelete: _platform.config.palette + "/bulk/delete/soft",
    bulkHardDelete: _platform.config.palette + "/bulk/delete/hard",
    bulkRestore: _platform.config.palette + "/bulk/delete/soft/restore"
  },
  crmImport: {
    importData: _platform.config.crmImport + "//crm/data",
    validateMapping: _platform.config.crmImport + "/crm/field-mapping/preflight",
    importMapping: _platform.config.crmImport + "/crm/field-mapping",
    downloadMapping: _platform.config.crmImport + "/crm/field-mapping/error/download"
  },
  crmExport: {
    export: _platform.config.crmExport + "/field-mapping"
  },
  crm: {
    list: _platform.config.crm + "/list",
    get: _platform.config.crm,
    update: _platform.config.crm,
    delete: _platform.config.crm,
    discponnect: _platform.config.crm + "/disconect",
    pause: _platform.config.crm + "/pause-or-resume"
  },
  crmFieldMapping: {
    list: _platform.config.crmFieldMapping + "/list",
    get: _platform.config.crmFieldMapping,
    update: _platform.config.crmFieldMapping,
    delete: _platform.config.crmFieldMapping,
    discponnect: _platform.config.crmFieldMapping + "/disconect",
    pause: _platform.config.crmFieldMapping + "/pause-or-resume",
    saveBulk: _platform.config.crmFieldMapping + "/bulk",
    testField: _platform.config.crmFieldMapping + "/test-fields"
  },
  templateContents: {
    fetch: _platform.config.templateContents,
    reportFetch: _platform.config.templateContents + "/report",
    list: _platform.config.templateContents + "/list",
    add: _platform.config.templateContents,
    update: _platform.config.templateContents,
    delete: _platform.config.templateContents + "/delete/hard",
    softDelete: _platform.config.templateContents + "/delete/soft",
    softDeleteRestore: _platform.config.templateContents + "/delete/soft/restore",
    softDeletedList: _platform.config.templateContents + "/list/soft/deleted",
    bulkSoftDelete: _platform.config.templateContents + "/bulk/delete/soft",
    bulkHardDelete: _platform.config.templateContents + "/bulk/delete/hard",
    bulkRestore: _platform.config.templateContents + "/bulk/delete/soft/restore",
    deleteReport: _platform.config.templateContents + "/report/delete/hard",
    softDeleteReport: _platform.config.templateContents + "/report/delete/soft",
    softDeleteRestoreReport: _platform.config.templateContents + "/report/delete/soft/restore",
    softDeletedListReport: _platform.config.templateContents + "/report/list/soft/deleted",
    bulkSoftDeleteReport: _platform.config.templateContents + "/bulk/report/delete/soft",
    bulkHardDeleteReport: _platform.config.templateContents + "/bulk/report/delete/hard",
    bulkRestoreReport: _platform.config.templateContents + "/bulk/report/delete/soft/restore"
  },
  systemInfo: {
    fetch: _platform.config.systemInfo + "/info"
  },
  standardTemplatePrintBridge: {
    list: _platform.config.standardTemplatePrintBridge + "/list",
    add: _platform.config.standardTemplatePrintBridge
  },
  accessCriteriaForReportData: {
    fetch: _platform.config.accessCriteriaForReportData + "/fund",
    add: _platform.config.accessCriteriaForReportData + "/fund",
    update: _platform.config.accessCriteriaForReportData + "/fund",
    fetchDonor: _platform.config.accessCriteriaForReportData + "/fund/donor",
    addDonor: _platform.config.accessCriteriaForReportData + "/fund/donor",
    updateDonor: _platform.config.accessCriteriaForReportData + "/fund/donor",
    fetchPerformance: _platform.config.accessCriteriaForReportData + "/fund/performance",
    addPerformance: _platform.config.accessCriteriaForReportData + "/fund/performance",
    updatePerformance: _platform.config.accessCriteriaForReportData + "/fund/performance",
    fetchImpact: _platform.config.accessCriteriaForReportData + "/fund/impact",
    addImpact: _platform.config.accessCriteriaForReportData + "/fund/impact",
    updateImpact: _platform.config.accessCriteriaForReportData + "/fund/impact"
  },
  accessCriteriaSoftDeleteForReportData: {
    softDeleteDetailTemporaryDeleteApi: _platform.config.accessCriteriaForReportData + "/fund/delete/soft",
    softDeleteDetailListApi: _platform.config.accessCriteriaForReportData + "/fund/list/soft/deleted",
    softDeleteDetailPermanentlyDeleteApi: _platform.config.accessCriteriaForReportData + "/fund/delete/hard",
    softDeleteDetailPermanentlyDeleteBulkApi: _platform.config.accessCriteriaForReportData + "/bulk/fund/delete/hard",
    softDeleteDetailRestoreApi: _platform.config.accessCriteriaForReportData + "/fund/delete/soft/restore",
    softDeleteDetailRestoreBulkApi: _platform.config.accessCriteriaForReportData + "/bulk/fund/delete/soft/restore",
    softDeletePerformanceTemporaryDeleteApi: _platform.config.accessCriteriaForReportData + "/fund/performance/delete/soft",
    softDeletePerformanceListApi: _platform.config.accessCriteriaForReportData + "/fund/performance/list/soft/deleted",
    softDeletePerformancePermanentlyDeleteApi: _platform.config.accessCriteriaForReportData + "/fund/performance/delete/hard",
    softDeletePerformancePermanentlyDeleteBulkApi: _platform.config.accessCriteriaForReportData + "/bulk/fund/performance/delete/hard",
    softDeletePerformanceRestoreApi: _platform.config.accessCriteriaForReportData + "/fund/performance/delete/soft/restore",
    softDeletePerformanceRestoreBulkApi: _platform.config.accessCriteriaForReportData + "/bulk/fund/performance/delete/soft/restore",
    softDeleteDonorTemporaryDeleteApi: _platform.config.accessCriteriaForReportData + "/fund/donor/delete/soft",
    softDeleteDonorListApi: _platform.config.accessCriteriaForReportData + "/fund/donor/list/soft/deleted",
    softDeleteDonorPermanentlyDeleteApi: _platform.config.accessCriteriaForReportData + "/fund/donor/delete/hard",
    softDeleteDonorPermanentlyDeleteBulkApi: _platform.config.accessCriteriaForReportData + "/bulk/fund/donor/delete/hard",
    softDeleteDonorRestoreApi: _platform.config.accessCriteriaForReportData + "/fund/donor/delete/soft/restore",
    softDeleteDonorRestoreBulkApi: _platform.config.accessCriteriaForReportData + "/bulk/fund/donor/delete/soft/restore",
    softDeleteImpactTemporaryDeleteApi: _platform.config.accessCriteriaForReportData + "/fund/impact/delete/soft",
    softDeleteImpactListApi: _platform.config.accessCriteriaForReportData + "/fund/impact/list/soft/deleted",
    softDeleteImpactPermanentlyDeleteApi: _platform.config.accessCriteriaForReportData + "/fund/impact/delete/hard",
    softDeleteImpactPermanentlyDeleteBulkApi: _platform.config.accessCriteriaForReportData + "/bulk/fund/impact/delete/hard",
    softDeleteImpactRestoreApi: _platform.config.accessCriteriaForReportData + "/fund/impact/delete/soft/restore",
    softDeleteImpactRestoreBulkApi: _platform.config.accessCriteriaForReportData + "/bulk/fund/impact/delete/soft/restore"
  },
  accountBulk: {
    enable: _platform.config.accountBulk + "/enable",
    disable: _platform.config.accountBulk + "/disable",
    softDelete: _platform.config.accountBulk + "/delete",
    restore: _platform.config.accountBulk + "/restore",
    hardDelete: _platform.config.accountBulk + "/bulk/delete-permanent",
    clean: _platform.config.accountBulk + "/clean"
  },
  efsFileChecker: {
    efsFileCheckerGetList: _platform.config.efsFileChecker + "/list",
    efsDownload: _platform.config.efsFileChecker + "/download"
  },
  public: {
    getTenantForEmail: _platform.config.platform + "/public/getTenantForEmail"
  }
};
exports.PlatformService = PlatformService;